import * as angular from "angular";
import * as _ from "lodash";
import {SplitService} from "./split-service.service";
import {TaskPurposeType} from "../types/task-purpose.type";
import {BranchReferenceModel} from "../../branches/models/branch-reference.model";
import {escapeHtml} from "../utils/html-escape.util";

export class BringozTimelineService {
  static $inject = ['tasksConstants', '$filter', 'splitService', 'moment', '$sanitize'];

  taskPurposeToColorMap: any;
  largeDistanceUnit: any;
  iconsUrl = {
    hash: 'assets/images/icons/v2/hash.svg',
    contact: 'assets/images/icons/v2/contact-circle.svg',
    phone: 'assets/images/icons/v2/phone-outline.svg',
    late: 'assets/images/icons/v2/error-outline.svg',
    relations: 'assets/images/icons/v2/relation.svg',
    address: 'assets/images/icons/v2/location-pin-outline.svg',
    weight: 'assets/images/icons/v2/weight.svg',
    volume: 'assets/images/icons/v2/volume.svg',
    eta: 'assets/images/icons/v2/eta.svg',
    geoTime: 'assets/images/icons/v2/geo-time.svg',
    status: 'assets/images/icons/v2/status.svg',
    serviceTime: 'assets/images/icons/v2/timer-outline.svg',
    idleTime: 'assets/images/icons/v2/idle-time.svg',
    timeWindow: 'assets/images/icons/v2/time-window-outline.svg',
    timeZone: 'assets/images/icons/v2/time-zone.svg',
    relation: 'assets/images/icons/v2/relation.svg',
    eyeOn: 'assets/images/icons/v2/show.svg',
    eyeOff: 'assets/images/icons/v2/hide.svg',
    linkTo: 'assets/images/icons/v2/link-to.svg',
    package: 'assets/images/icons/v2/package-outline.svg',
    account: 'assets/images/icons/v2/account.svg',
    routed: 'assets/images/icons/v2/route.svg',
    price: 'assets/images/icons/v2/dollar-circle.svg',
    serviceArea: 'assets/images/icons/v2/service-area.svg',
    recurring: 'assets/images/icons/v2/recurring.svg',
    note: 'assets/images/icons/v2/note.svg',
    tag: 'assets/images/icons/v2/tag.svg',
    break: 'assets/images/icons/v2/timer-outline.svg',
    blocked: 'assets/images/icons/v2/lock-outline.svg',
    agent: {
      Driver: 'assets/images/icons/agents/driver_flat.svg',
      ServiceAgent: 'assets/images/icons/agents/serviceagent_flat.svg'
    }
  }
  $hashIcon = document.createElement('IMG');
  $contactIcon = document.createElement('IMG');
  $phoneIcon = document.createElement('IMG');
  $addressIcon = document.createElement('IMG');
  $etaIcon = document.createElement('IMG');
  $statusIcon = document.createElement('IMG');
  $geoTimeIcon = document.createElement('IMG');
  $serviceTimeIcon = document.createElement('IMG');
  $lateIcon = document.createElement('IMG');
  $idleTimeIcon = document.createElement('IMG');
  $timeWindowIcon = document.createElement('IMG');
  $timeWindowWhiteIcon = document.createElement('IMG');
  $timeZoneIcon = document.createElement('IMG');
  $weightIcon = document.createElement('IMG');
  $volumeIcon = document.createElement('IMG');
  $linkedIcon = document.createElement('IMG');
  $packageIcon = document.createElement('IMG');
  $accountIcon = document.createElement('IMG');
  $routedIcon = document.createElement('IMG');
  $noteWhiteIcon = document.createElement('IMG');
  $routedWhiteIcon = document.createElement('IMG');
  $priceIcon = document.createElement('IMG');
  $recurringIcon = document.createElement('IMG');
  $recurringWhiteIcon = document.createElement('IMG');
  $breakWhiteIcon = document.createElement('IMG');
  $breakIcon = document.createElement('IMG');
  $serviceAreaIcon = document.createElement('IMG');
  $noteIcon = document.createElement('IMG');
  $tagIcon = document.createElement('IMG');

  private _customTooltipEl: HTMLDivElement | null = null;
  private _tooltipTimeout: any = null;
  private _lastMousePosition: { clientX: number, clientY: number } | null = null;
  private TOOLTIP_TIMEOUT_INTERVAL: number = 500;

  constructor(private tasksConstants, private $filter, private splitService: SplitService, private moment, private $sanitize) {
    this.taskPurposeToColorMap = tasksConstants.purposeToColor;
    this.largeDistanceUnit = this.splitService.getSiteDistanceLargeUnit();

    this.$hashIcon.setAttribute("src", this.iconsUrl.hash);
    this.$hashIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$contactIcon.setAttribute("src", this.iconsUrl.contact);
    this.$contactIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$phoneIcon.setAttribute("src", this.iconsUrl.phone);
    this.$phoneIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$addressIcon.setAttribute("src", this.iconsUrl.address);
    this.$addressIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$etaIcon.setAttribute("src", this.iconsUrl.eta);
    this.$etaIcon.classList.add('bringoz-icon-medium', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$statusIcon.setAttribute("src", this.iconsUrl.status);
    this.$statusIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$geoTimeIcon.setAttribute("src", this.iconsUrl.geoTime);
    this.$geoTimeIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$serviceTimeIcon.setAttribute("src", this.iconsUrl.serviceTime);
    this.$serviceTimeIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$lateIcon.setAttribute("src", this.iconsUrl.serviceTime);
    this.$lateIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'warn');

    this.$idleTimeIcon.setAttribute("src", this.iconsUrl.idleTime);
    this.$idleTimeIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$timeWindowIcon.setAttribute("src", this.iconsUrl.timeWindow);
    this.$timeWindowIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$timeWindowWhiteIcon.setAttribute("src", this.iconsUrl.timeWindow);
    this.$timeWindowWhiteIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'white');

    this.$timeZoneIcon.setAttribute("src", this.iconsUrl.timeZone);
    this.$timeZoneIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$weightIcon.setAttribute("src", this.iconsUrl.weight);
    this.$weightIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$volumeIcon.setAttribute("src", this.iconsUrl.volume);
    this.$volumeIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$linkedIcon.setAttribute("src", this.iconsUrl.relation);
    this.$linkedIcon.classList.add('agent-icon');

    this.$packageIcon.setAttribute("src", this.iconsUrl.package);
    this.$packageIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$accountIcon.setAttribute("src", this.iconsUrl.account);
    this.$accountIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$routedIcon.setAttribute("src", this.iconsUrl.routed);
    this.$routedIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$routedWhiteIcon.setAttribute("src", this.iconsUrl.routed);
    this.$routedWhiteIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'white');

    this.$priceIcon.setAttribute("src", this.iconsUrl.price);
    this.$priceIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$recurringIcon.setAttribute("src", this.iconsUrl.recurring);
    this.$recurringIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$recurringWhiteIcon.setAttribute("src", this.iconsUrl.recurring);
    this.$recurringWhiteIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'white');

    this.$breakWhiteIcon.setAttribute("src", this.iconsUrl.break);
    this.$breakWhiteIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'white');

    this.$breakWhiteIcon.setAttribute("src", this.iconsUrl.break);
    this.$breakWhiteIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'white');

    this.$breakIcon.setAttribute("src", this.iconsUrl.break);
    this.$breakIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon');

    this.$serviceAreaIcon.setAttribute("src", this.iconsUrl.serviceArea);
    this.$serviceAreaIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$noteIcon.setAttribute("src", this.iconsUrl.note);
    this.$noteIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

    this.$noteWhiteIcon.setAttribute("src", this.iconsUrl.note);
    this.$noteWhiteIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'white');

    this.$tagIcon.setAttribute("src", this.iconsUrl.tag);
    this.$tagIcon.classList.add('bringoz-icon-small', 'bringoz-timeline-tooltip-icon', 'grey');

  }

  // ==========================================
  // Custom Timeline Tooltip Logic
  // ==========================================

  public initCustomTooltip(timeline: any, itemsDataSet: any, hostElementSelector?: string) {
    // Custom Tooltip Events
    timeline.on('itemover', (properties) => {
      if (properties.item) {
        const item = itemsDataSet.get(properties.item);
        if (item && item.title) {
          if (this._tooltipTimeout) {
            clearTimeout(this._tooltipTimeout);
          }
          this._lastMousePosition = { clientX: properties.event.clientX, clientY: properties.event.clientY };
          this._tooltipTimeout = setTimeout(() => {
            if (this._lastMousePosition) {
              this._showCustomTooltip(item, this._lastMousePosition as MouseEvent, hostElementSelector);
            }
          }, this.TOOLTIP_TIMEOUT_INTERVAL);
        }
      }
    });

    timeline.on('itemout', (properties) => {
       this.hideCustomTooltip();
    });

    timeline.on('mouseMove', (properties) => {
      this._lastMousePosition = { clientX: properties.event.clientX, clientY: properties.event.clientY };

      if (this._customTooltipEl && this._customTooltipEl.style.display !== 'none' && properties.item) {
        // Only update position if it's currently showing
        this._updateCustomTooltipPosition(properties.event);
      }
    });
  }

  private _showCustomTooltip(itemRef: any, e: MouseEvent, hostElementSelector?: string) {
    if (!itemRef || !itemRef.title) return;

    if (!this._customTooltipEl) {
      this._customTooltipEl = document.createElement('div');
      this._customTooltipEl.className = 'vis-tooltip bringoz-tooltip';
      this._customTooltipEl.style.position = 'fixed';
      this._customTooltipEl.style.zIndex = '2147483647'; // Max z-index
      this._customTooltipEl.style.pointerEvents = 'none';

      let componentHost;
      if (hostElementSelector) {
        componentHost = document.querySelector(hostElementSelector) || document.body;
      } else {
        componentHost = document.body;
      }
      componentHost.appendChild(this._customTooltipEl);
    }

    this._customTooltipEl.innerHTML = this.sanitizeTimelineHtml(itemRef.title);
    this._customTooltipEl.style.visibility = 'hidden';
    this._customTooltipEl.style.display = 'block';

    this._updateCustomTooltipPosition(e);
  }

  private _updateCustomTooltipPosition(e: MouseEvent | { clientX: number, clientY: number }) {
    if (!this._customTooltipEl || this._customTooltipEl.style.display === 'none') return;

    requestAnimationFrame(() => {
      if (!this._customTooltipEl) return;
      const rect = this._customTooltipEl.getBoundingClientRect();

      let left = e.clientX + 15;
      let top = e.clientY + 15;

      // Flip if going off screen
      if (left + rect.width > window.innerWidth) {
        left = e.clientX - rect.width - 15;
      }
      if (top + rect.height > window.innerHeight) {
        top = e.clientY - rect.height - 15;
      }

      this._customTooltipEl.style.left = `${left}px`;
      this._customTooltipEl.style.top = `${top}px`;
      this._customTooltipEl.style.visibility = 'visible';
    });
  }

  public hideCustomTooltip() {
    if (this._tooltipTimeout) {
      clearTimeout(this._tooltipTimeout);
      this._tooltipTimeout = null;
    }
    if (this._customTooltipEl) {
      this._customTooltipEl.style.display = 'none';
    }
  }

  public destroyCustomTooltip() {
    this.hideCustomTooltip();
    if (this._customTooltipEl) {
      this._customTooltipEl.remove();
      this._customTooltipEl = null;
    }
  }

  public sanitizeTimelineHtml(html: any): string {
    if (html === undefined || html === null) {
      return '';
    }

    return this.$sanitize(String(html));
  }

  public escapeTimelineText(value: any, fallback: string = ''): string {
    return escapeHtml(value, fallback);
  }

  // Shifts
  getShiftContent(shift, notBefore, notAfter) {
    let timeWindowTextRef = this.$filter('timeWindow')({
      notBefore: this.moment(notBefore).valueOf(),
      notAfter: this.moment(notAfter).valueOf()
    });
    let scheduleName = this.escapeTimelineText(_.get(shift, 'agentSchedule.name', '---'));
    const isRecurring = !!shift.agentSchedule.templateId && !shift.agentSchedule.template && !shift.agentSchedule.overridden;
    // var hasRoute = _.chain(shift.scheduleExtraData)
    //   .filter((e) => {
    //     if (!!e.routeId) {
    //       return moment(moment(notBefore).format("MM/DD/YYYY")).isSame(moment(e.eventDate).format("MM/DD/YYYY"));
    //     } else {
    //       return false;
    //     }
    //   })
    //   .head()
    //   .value()

    let extraDataItem = _.get(shift, 'scheduleExtraData[0]');

    let breakRef = _.get(extraDataItem, 'breaks[0]');
    let breakRow = '';

    let breakNoteRef = _.get(extraDataItem, 'internalNote');
    let breakNoteRow = '';

    if (!!breakRef) {
      const breakFrom = this.$filter('bringozTime')(breakRef, 'notBefore');
      const breakTo = this.$filter('bringozTime')(breakRef, 'endDate', (breakRef.notBefore + breakRef.duration));
      const breakTest = this.$filter('translate')('Break');
      breakRow = '<div class="item-row padding-left-5 padding-right-5 text-ellipsis">'
        + this.$breakIcon.outerHTML
        + '<span class="br-body-1">' + breakTest + ': ' + breakFrom + ' - ' + breakTo + '</span>'
        + '</div>'
    }

    if (!!breakNoteRef) {
      breakNoteRow = '<div class="item-row padding-left-5 padding-right-5 text-ellipsis">'
        + this.$noteIcon.outerHTML
        + '<span class="br-body-1">' + this.escapeTimelineText(breakNoteRef.text) + '</span>'
        + '</div>'
    }

    return '<div class="item-container">'
      + '<div class="item-row padding-left-5 padding-right-5">'
      + '<span class="br-body-1 font-weight-500 flex-item">' + (isRecurring ? '&#8634; ' : '') + scheduleName + '</span>'
      + '</div>'
      + '<div class="item-row padding-left-5 padding-right-5">'
      // + this.$timeWindowWhiteIcon.outerHTML
      + '<span class="br-body-1 font-weight-500">' + timeWindowTextRef + '</span>'
      + '</div>'
      + breakRow
      + breakNoteRow
      + '</div>'
  }

  // Shifts
  getShiftContentNew(shift, notBefore, notAfter) {
    let timeWindowTextRef = this.$filter('timeWindow')({
      notBefore: this.moment(notBefore).valueOf(),
      notAfter: this.moment(notAfter).valueOf()
    });
    let scheduleName = this.escapeTimelineText(_.get(shift, 'agentSchedule.name', '---'));
    const isRecurring = !!shift.agentSchedule.templateId && !shift.agentSchedule.template && !shift.agentSchedule.overridden;

    let extraDataItem = _.get(shift, 'scheduleExtraData[0]');

    let shiftNoteRef = _.get(extraDataItem, 'internalNote');
    let shiftNoteRow = '';

    if (!!shiftNoteRef) {
      shiftNoteRow = this.$noteIcon.outerHTML
        + '<span class="br-body-1">' + this.escapeTimelineText(shiftNoteRef.text) + '</span>'
    }


    let breakNoteRef = _.get(extraDataItem, 'breaks[0].internalNote');
    let breakNoteRow = '';

    if (!!breakNoteRef) {
      breakNoteRow = this.$noteIcon.outerHTML
        + '<span class="br-body-1">' + this.escapeTimelineText(breakNoteRef.text) + '</span>'
    }

    return '<div class="item-container">'
      + '<div class="item-row padding-right-5 font-weight-500">'
      + shiftNoteRow
      + breakNoteRow
      + '<span class="margin-left-5 margin-right-5 font-weight-500">' + `${timeWindowTextRef}` + '</span>'
      + '<span class="font-weight-500">' + `${scheduleName} ${(isRecurring ? '&#8634; ' : '')}` + '</span>'
      + '</div>'
      + '</div>'

    // return '<div class="item-container">'
    //   + '<div class="item-row padding-left-5 padding-right-5">'
    //   + '<span class="br-body-1 font-weight-500 flex-item">' + (isRecurring ? '&#8634; ' : '') + scheduleName + '</span>'
    //   + '</div>'
    //   + '<div class="item-row padding-left-5 padding-right-5">'
    //   // + this.$timeWindowWhiteIcon.outerHTML
    //   + '<span class="br-body-1 font-weight-500">' + timeWindowTextRef + '</span>'
    //   + '</div>'
    //   + breakRow
    //   + breakNoteRow
    //   + '</div>'
  }

  getShiftTimelineItemTooltip(shift, route?, serviceAreasOptions?) {
    const zoneId = shift.agentSchedule.holderZoneId ? shift.agentSchedule.holderZoneId : shift.agentSchedule.schedule.zoneIdName;
    const timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(zoneId, shift.agentSchedule.schedule.startTime);
    const zoneIdText = this.escapeTimelineText(zoneId);
    const scheduleExtraDataRef = _.get(shift, 'scheduleExtraData[0]');

    const shiftServiceAreas = _.filter(serviceAreasOptions, (s) => {
      return _.includes(_.get(shift, 'agentSchedule.serviceAreaIds', []), s.id);
    })
    const serviceAreasDisplayString = this.getServiceAreaNames(shiftServiceAreas);
    const isRecurring = !!shift.agentSchedule.templateId && !shift.agentSchedule.template && !shift.agentSchedule.overridden;

    let scheduleTypeReason = '';
    let routedRow = '';
    let noteRow = '';
    let timeWindowZoneRow = '';
    let totalRouteTimeSecRow = '';
    let totalRouteTravelTimeRow = '';

    if (!!shift.agentSchedule?.scheduleTypeReason) {
      scheduleTypeReason = '<div class="info-row">'
        + this.$noteIcon.outerHTML
        + '<span class="br-body-1">' + this.escapeTimelineText(shift.agentSchedule.scheduleTypeReason) + '</span>'
        + '</div>'
    }

    if (!!scheduleExtraDataRef?.routeId) {
      routedRow = '<div class="info-row">'
        + this.$routedIcon.outerHTML
        + '<span class="br-body-1">' + this.escapeTimelineText(scheduleExtraDataRef.routeId) + '</span>'
        + '</div>'
    }

    if (scheduleExtraDataRef?.breaks?.length && !!scheduleExtraDataRef.breaks[0].internalNote) {
      noteRow = '<div class="info-row">'
        + this.$noteIcon.outerHTML
        + '<span class="br-body-1 margin-right-10">' + this.escapeTimelineText(_.get(scheduleExtraDataRef, 'breaks[0].internalNote.text')) + '</span>'
        + '</div>'
    }

    if (!!route?.totals?.totalTimeSec) {
      totalRouteTimeSecRow = '<div class="info-row">'
        + this.$serviceTimeIcon.outerHTML
        + '<span class="br-body-1">' + this.$filter('translate')('Route Total Time') + ': ' + this.$filter('bringozTimeConvert')(route.totals.totalTimeSec) + '</span>'
        + '</div>'
    }

    if (!!route?.totals?.totalTravelTimeSec) {
      totalRouteTravelTimeRow = '<div class="info-row">'
        + this.$serviceTimeIcon.outerHTML
        + '<span class="br-body-1">' + this.$filter('translate')('Route Driving Time') + ': ' + this.$filter('bringozTimeConvert')(route.totals.totalTravelTimeSec) + '</span>'
        + '</div>'
    }

    const dateDisplay = this.$filter('bringozDate')({date: shift.agentSchedule.schedule.startTime}, 'date');
    const startTime = this.$filter('bringozTime')(shift.agentSchedule.schedule, 'startTime');
    const endTime = this.$filter('bringozTime')(shift.agentSchedule.schedule, 'endTime');

    if (!_.isUndefined(timeZoneOffsetDiff) && timeZoneOffsetDiff !== 0) {
      timeWindowZoneRow = '<span class="info-row">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-1">' + zoneIdText + ' (' + timeZoneOffsetDiff + this.$filter('translate')('hrs') + ')' + ' | </span>\n'
        + '<span class="br-body-1 margin-left-5">' + this.$filter('timeWindow')({
          notBefore: shift.agentSchedule.schedule.startTime,
          notAfter: shift.agentSchedule.schedule.endTime
        }, zoneId) + ' </span>'
        + '</span>'
    }

    return '<div class="header-container">'
      + '<span class="br-body-2">' + this.escapeTimelineText(shift.agentSchedule.name) + '</span>'
      + (isRecurring ? this.$recurringIcon.outerHTML : '')
      + '</div>'
      + '<div class="info-row">'
      + this.$timeWindowIcon.outerHTML
      + '<span class="br-body-1 margin-right-10">' + dateDisplay + ' ' + startTime + ' - ' + endTime + '</span>'
      + '</div>'
      + timeWindowZoneRow
      + '<div class="info-row">'
      + this.$serviceAreaIcon.outerHTML
      + '<span class="br-body-1 margin-right-10">' + serviceAreasDisplayString + '</span>'
      + '</div>'
      + scheduleTypeReason
      + routedRow
      + totalRouteTimeSecRow
      + totalRouteTravelTimeRow
      + noteRow;
  }

  getAgentIrregularityTooltip(irregularity, irregularityType) {
    let irregularityDescription;

    if (irregularityType === 'outOfServiceAreaIrregularity') {
      irregularityDescription = this.$filter('bringozTime')(irregularity, 'fromDate') + '-' + this.$filter('bringozTime')(irregularity, 'toDate') + ' ' +
        this.$filter('translate')('Out of Service Area');
    }

    if (irregularityType === 'taskCompletionLocationIrregularity') {
      irregularityDescription = this.$filter('translate')('TASK_COMPLETION_DISTANCE', {
        value: irregularity.distanceFromTaskLocationInKm,
        unit: this.largeDistanceUnit
      })
    }

    return '<div class="header-container">'
      + '<span class="br-body-2 font-weight-400">' + this.escapeTimelineText(irregularityDescription) + '</span>'
      + '</div>'
  }

  // Itinerary
  getTaskTimelineItemContent(task?, relations?, showStatus?, index?) {
    const purpose = task.taskSpec.purpose;
    const status = this.escapeTimelineText(task.status);
    const isLate = _.get(task, 'analysis.late', 0) > 0;
    let taskIndex = index || _.get(task, 'analysis.daySequence');
    let statusIndication;

    if (!taskIndex || taskIndex <= 0) {
      taskIndex = '';
    }

    let relationIcon;
    if (relations && relations.length) {
      relationIcon = document.createElement('IMG');
      relationIcon.setAttribute("src", this.iconsUrl.relations);
      relationIcon.classList.add('bringoz-icon-small', 'white');
    }

    let lateIcon;
    if (isLate) {
      lateIcon = document.createElement('IMG');
      lateIcon.setAttribute("src", this.iconsUrl.late);
      lateIcon.classList.add('bringoz-icon', 'warn');
    }

    if (showStatus) {
      statusIndication = document.createElement('div');
      statusIndication.classList.add('status-container', status);
    }

    return `<div class="item-warn-container">${(isLate ? '&#9888;' : '')}</div>
            <span class="br-caption-2">${this.$filter('translate')(purpose.charAt(0))} ${taskIndex}</span>
            <div class="item-status-container">${(showStatus ? statusIndication.outerHTML : '')}</div>`;
  }

  getBundleTaskTimelineItemContent(task?, relations?, showStatus?, index?) {
    const purpose = task.taskSpec.purpose;
    const isLate = _.get(task, 'analysis.late', 0) > 0;
    const status = this.escapeTimelineText(task.status);
    let numberOfStops = _.get(task, 'bundledTaskList', []).length
    let taskIndex = index || _.get(task, 'analysis.daySequence');
    let statusIndication;

    if (!taskIndex || taskIndex <= 0) {
      taskIndex = '';
    }

    let relationIcon;
    if (relations && relations.length) {
      relationIcon = document.createElement('IMG');
      relationIcon.setAttribute("src", this.iconsUrl.relations);
      relationIcon.classList.add('bringoz-icon-small', 'white');
    }

    let lateIcon;
    if (isLate) {
      lateIcon = document.createElement('IMG');
      lateIcon.setAttribute("src", this.iconsUrl.late);
      lateIcon.classList.add('bringoz-icon-small', 'warn');
    }

    if (showStatus) {
      statusIndication = document.createElement('div');
      statusIndication.classList.add('status-container', status);
    }

    return `<div class="item-warn-container">${(lateIcon ? lateIcon.outerHTML : '')}</div>
            <span class="br-caption-2">${this.$filter('translate')(purpose.charAt(0))} ${taskIndex}</span>
            <div class="item-status-container">${(showStatus ? statusIndication.outerHTML : '')}</div>`;
  }

  getInternalItemContent(task, showStatus) {
    let statusIndication;
    const purpose = task.taskSpec.purpose;
    const status = this.escapeTimelineText(task.status);
    const label = this.$filter('translate')(purpose.charAt(0));

    if (showStatus) {
      statusIndication = document.createElement('div');
      statusIndication.classList.add('status-container', status);
    }

    return `${(showStatus ? statusIndication.outerHTML : '')}
            <span class="br-caption-2 ' + ${label} + '">${label}</span>`;
  }

  getTaskExtendedTimelineItemTooltip(task?, taskEtaWindow?, relations?, index?) {

    const purpose = task.taskSpec.purpose;
    const isBundle = _.isEqual(task.taskType, 'BundledStopover');
    const purposeColor = this.escapeTimelineText(this.taskPurposeToColorMap[purpose]);
    const status = this.escapeTimelineText(task.status);
    const isLate = _.get(task, 'analysis.late', 0) > 0;
    const analysis = _.get(task, 'analysis');
    const eta = _.get(task, 'analysis.eta');
    let serviceTime;
    if(!!task.taskSpec.detailedServiceTime) {
      const detailedServiceTime = task.taskSpec.detailedServiceTime;
      serviceTime = (detailedServiceTime.workTime || 0) + (detailedServiceTime.entryTime || 0) + (detailedServiceTime.exitTime || 0) + (detailedServiceTime.packagesTime || 0);
    } else {
      serviceTime = _.get(task, 'taskSpec.serviceTime');
    }
    const actualNotBefore = _.get(task, 'analysis.actualNotBefore', 0);
    const idleInMili = actualNotBefore > eta ? (actualNotBefore - eta) : 0;
    const weight = _.get(task, 'analysis.currentLoad.weight');
    const volume = _.get(task, 'analysis.currentLoad.dimensions.cube');
    let taskIndex = _.get(task, 'analysis.daySequence');
    const notBefore = _.get(task, 'taskSpec.notBefore');
    const notAfter = _.get(task, 'taskSpec.notAfter');
    const taskTimeWindow = {notBefore: notBefore, notAfter: notAfter};
    const timeZoneId = _.get(task, 'taskSpec.address.zoneIdName');
    const timeZoneIdText = this.escapeTimelineText(timeZoneId);
    const timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(timeZoneId, notBefore);
    const accountName = this.escapeTimelineText(_.get(task, 'accountReference.name', '--'));
    const packagesCount = _.get(task, 'packageList[0].count');
    let packagesRow = '';
    const tooltipHeader = this.escapeTimelineText((isBundle ? this.$filter('translate')('Multi') + ' ' : '') + purpose);
    const serviceId = this.escapeTimelineText(task.serviceId);
    let serviceIdRow = '';
    let timeWindowZoneRow = '';
    let etaZoneRow = '';
    let tagsRow = '';
    const courierPrice = this.escapeTimelineText(this.$filter('taskCourierPrice')(task));
    let courierPriceRow = '';
    const contactName = this.escapeTimelineText(_.get(task, 'taskSpec.contact.fullName', '---'));
    const contactPhone = _.get(task, 'taskSpec.contact.phoneNo');
    const routeId = this.escapeTimelineText(_.get(task, 'routeId'));
    const tags = !isBundle ? _.get(task, 'serviceInfo.tagNames') : _.uniq(_.flatMap(task.bundledTaskList, 'serviceInfo.tagNames'));
    let routedRow = '';


    if (!taskIndex || taskIndex <= 0) {
      taskIndex = index || '';
    }

    if (!!serviceId) {
      serviceIdRow = '<div class="info-row margin-left-10">'
        + this.$hashIcon.outerHTML
        + '<span class="br-body-1">' + serviceId + '</span>'
        + '</div>'
    }

    if (!!routeId) {
      routedRow = '<div class="info-row">'
        + this.$routedIcon.outerHTML
        + '<span class="br-body-1">' + routeId + '</span>'
        + '</div>'
    }

    if (!!courierPrice) {
      courierPriceRow = '<div class="info-row">'
        + this.$priceIcon.outerHTML
        + '<span class="br-body-1">' + this.$filter('translate')('Cost') + ': ' + courierPrice + '</span>'
        + '</div>'
    }

    if (packagesCount > 0) {
      packagesRow = '<div class="info-row">'
        + '<span class="br-body-1 margin-right-5">X' + packagesCount + ',</span>'
        + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Weight') + ': ' + this.$filter('bringozWeight')(weight, true) + ',</span>'
        + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Volume') + ': ' + this.$filter('bringozVolume')(volume, true) + ',</span>'
        + '<span class="br-body-1">' + this.$filter('translate')('Product Value') + ': ' + this.$filter('packageTotalValue')(task.packageList[0], true) + '</span>'
        + '</div>'
    }

    let relationIcon;
    if (relations && relations.length) {
      relationIcon = document.createElement('IMG');
      relationIcon.setAttribute("src", this.iconsUrl.relations);
      relationIcon.classList.add('bringoz-icon-small', 'white');
    }

    if (!_.isUndefined(timeZoneOffsetDiff) && timeZoneOffsetDiff !== 0) {
      timeWindowZoneRow = '<span class="info-row margin-left-5">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-1" style="color: #317AD5;">' + this.escapeTimelineText(this.$filter('timeWindow')(taskTimeWindow, timeZoneId)) + ' | </span>\n'
        + '<span class="br-body-1" style="color: #317AD5;">' + timeZoneIdText + ' (' + timeZoneOffsetDiff + this.$filter('translate')('hrs') + ')' + '</span>'
        + '</span>'
    }

    if (!_.isUndefined(timeZoneOffsetDiff) && !_.isUndefined(eta) && timeZoneOffsetDiff !== 0) {
      etaZoneRow = '<span class="info-row margin-left-5">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-1" style="color: #317AD5;">' + this.escapeTimelineText(this.$filter('bringozDate')({eta: eta}, 'eta', true, timeZoneId)) + ' | </span>\n'
        + '<span class="br-body-1" style="color: #317AD5;">' + timeZoneIdText + ' (' + timeZoneOffsetDiff + this.$filter('translate')('hrs') + ')' + '</span>'
        + '</span>'
    }

    if (!!tags) {
      tagsRow = '<div class="info-row">'
        + this.$tagIcon.outerHTML
        + '<span class="br-body-1 margin-right-10">' + this.getTagsNames(tags) + '</span>'
        + '</div>'
    }

    return '<div class="header-container">'
      + '<div class="task-status ' + status + '">' + this.$filter('translate')('STATUS_TAG.' + status) + '</div>'
      + '<span style="color: ' + purposeColor + '" class="task-purpose br-body-2 font-weight-600 margin-left-5">' + tooltipHeader + ' ' + taskIndex + '</span>'
      + (relationIcon ? relationIcon.outerHTML : '')
      + serviceIdRow
      + '</div>'
      + routedRow
      + '<div class="info-row">'
      + this.$accountIcon.outerHTML
      + '<span class="br-body-1">' + accountName + '</span>'
      + '</div>'
      + '<div class="info-row">'
      + this.$addressIcon.outerHTML
      + '<span class="br-body-1">' + this.escapeTimelineText(this.$filter('bringozAddress')(task.taskSpec.address)) + '</span>'
      + '</div>'
      + '<div class="info-row">'
      + this.$contactIcon.outerHTML
      + '<span bringoz-ppi class="br-body-1 margin-right-10">' + contactName + '</span>'
      + this.$phoneIcon.outerHTML
      + '<span bringoz-ppi class="br-body-1">' + this.escapeTimelineText(this.$filter('bringozPhone')(contactPhone, '---')) + '</span>'
      + '</div>'
      + '<div class="info-row">'
      + this.$timeWindowIcon.outerHTML
      + '<span class="br-body-1">' + this.$filter('timeWindow')(taskTimeWindow) + '</span>'
      + timeWindowZoneRow
      + '</div>'
      + '<div class="info-row">'
      + this.$serviceTimeIcon.outerHTML
      + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Service Time') + ': ' + this.$filter('serviceTime')(serviceTime) + ', </span>'
      + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Idle Time') + ': ' + this.$filter('bringozTimeConvert')(idleInMili, true) + '</span>'
      + '</div>'
      + '<div class="info-row">'
      + this.$etaIcon.outerHTML
      + '<span class="br-body-1' + (isLate ? 'warn' : '') + '">' + this.$filter('bringozTime')(analysis, 'eta') + '</span>'
      + (isLate ? this.$lateIcon.outerHTML : '')
      + etaZoneRow
      + '</div>'
      + tagsRow
      + packagesRow
      + courierPriceRow
  }


  // Routes
  getRouteTaskTimelineItemContent(task?, relations?, showStatus?, index?) {
    const purpose = task.taskSpec.purpose;
    const status = this.escapeTimelineText(task.status);
    const isLate = _.get(task, 'routeAnalysis.late', 0) > 0;
    let taskIndex = index || _.get(task, 'routeAnalysis.daySequence');
    let statusIndication;

    if (!taskIndex || taskIndex <= 0) {
      taskIndex = '';
    }

    let relationIcon;
    if (relations && relations.length) {
      relationIcon = document.createElement('IMG');
      relationIcon.setAttribute("src", this.iconsUrl.relations);
      relationIcon.classList.add('bringoz-icon-small', 'white');
    }

    let lateIcon;
    if (isLate) {
      lateIcon = document.createElement('IMG');
      lateIcon.setAttribute("src", this.iconsUrl.late);
      lateIcon.classList.add('bringoz-icon', 'warn');
    }

    if (showStatus) {
      statusIndication = document.createElement('div');
      statusIndication.classList.add('status-container', status);
    }

    return `<span class="br-caption-2">${this.$filter('translate')(purpose.charAt(0))} ${taskIndex}</span>
            <div class="item-status-container margin-left-5">${(showStatus ? statusIndication.outerHTML : '')}</div>
            <div class="item-warn-container">${(isLate ? '&#9888;' : '')}</div>`;
  }

  getRouteBundleTaskTimelineItemContent(task, relations, showStatus, index?) {
    const purpose = task.taskSpec.purpose;
    const isLate = _.get(task, 'routeAnalysis.late', 0) > 0;
    const status = this.escapeTimelineText(task.status);
    let numberOfStops = _.get(task, 'bundledTaskList', []).length
    let taskIndex = index || _.get(task, 'routeAnalysis.daySequence');
    let statusIndication;

    if (!taskIndex || taskIndex <= 0) {
      taskIndex = '';
    }

    let relationIcon;
    if (relations && relations.length) {
      relationIcon = document.createElement('IMG');
      relationIcon.setAttribute("src", this.iconsUrl.relations);
      relationIcon.classList.add('bringoz-icon-small', 'white');
    }

    let lateIcon;
    if (isLate) {
      lateIcon = document.createElement('IMG');
      lateIcon.setAttribute("src", this.iconsUrl.late);
      lateIcon.classList.add('bringoz-icon-small', 'warn');
    }

    if (showStatus) {
      statusIndication = document.createElement('div');
      statusIndication.classList.add('status-container', status);
    }

    return `<div class="item-warn-container">${(isLate ? this.$lateIcon.outerHTML : '')}</div>
            <span class="br-caption-2">${this.$filter('translate')(purpose.charAt(0))} ${taskIndex}</span>
            <div class="item-status-container">${(showStatus ? statusIndication.outerHTML : '')}</div>`;
  }

  getRouteInternalItemContent(task, showStatus?) {
    let statusIndication;
    const purpose = task.taskSpec.purpose;
    const status = this.escapeTimelineText(task.status);
    const label = this.$filter('translate')(purpose.charAt(0));

    if (showStatus) {
      statusIndication = document.createElement('div');
      statusIndication.classList.add('status-container', status);
    }

    return `${(showStatus ? statusIndication.outerHTML : '')}
            <span class="br-caption-2 ' + ${label} + '">${label}</span>`;
  }

  getRouteTaskExtendedTimelineItemTooltip(task, taskEtaWindow, relations, index?, route?) {
    const purpose = task.taskSpec.purpose;
    const isBundle = _.isEqual(task.taskType, 'BundledStopover');
    const purposeColor = this.escapeTimelineText(this.taskPurposeToColorMap[purpose]);
    const externalId = this.escapeTimelineText(_.get(task, 'serviceExternalId'));
    const status = this.escapeTimelineText(task.status);
    const isLate = _.get(task, 'routeAnalysis.late', 0) > 0;
    const analysis = _.get(task, 'routeAnalysis');
    const eta = _.get(task, 'routeAnalysis.eta');
    let serviceTime;
    if(!!task.taskSpec.detailedServiceTime) {
      const detailedServiceTime = task.taskSpec.detailedServiceTime;
      serviceTime = (detailedServiceTime.workTime || 0) + (detailedServiceTime.entryTime || 0) + (detailedServiceTime.exitTime || 0) + (detailedServiceTime.packagesTime || 0);
    } else {
      serviceTime = _.get(task, 'taskSpec.serviceTime');
    }
    const actualNotBefore = _.get(task, 'routeAnalysis.actualNotBefore', 0);
    const idleInMili = actualNotBefore > eta ? (actualNotBefore - eta) : 0;
    const weight = _.get(task, 'routeAnalysis.currentLoad.weightLoad');
    const volume = _.get(task, 'routeAnalysis.currentLoad.calculatedVolume');
    let taskIndex = _.get(task, 'routeAnalysis.daySequence');
    const notBefore = _.get(task, 'taskSpec.notBefore');
    const notAfter = _.get(task, 'taskSpec.notAfter');
    const taskTimeWindow = {notBefore: notBefore, notAfter: notAfter};
    const timeZoneId = _.get(task, 'taskSpec.address.zoneIdName');
    const timeZoneIdText = this.escapeTimelineText(timeZoneId);
    const timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(timeZoneId, notBefore);
    const accountName = this.escapeTimelineText(_.get(task, 'accountReference.name', '--'));
    const packagesCount = _.get(task, 'packageList[0].count');
    let packagesRow = '';
    const tooltipHeader = this.escapeTimelineText((isBundle ? this.$filter('translate')('Multi') + ' ' : '') + purpose);
    const serviceId = this.escapeTimelineText(task.serviceId);
    let serviceIdRow = '';
    let externalIdRow = '';
    let timeWindowZoneRow = '';
    let etaZoneRow = '';
    let tagsRow = '';
    const courierPrice = this.escapeTimelineText(this.$filter('taskCourierPrice')(task));
    let courierPriceRow = '';
    const contactName = this.escapeTimelineText(_.get(task, 'taskSpec.contact.fullName', '--'));
    const contactPhone = _.get(task, 'taskSpec.contact.phoneNo');
    const routeId = this.escapeTimelineText(_.get(task, 'routeId'));
    const tags = !isBundle ? _.get(task, 'serviceInfo.tagNames') : _.uniq(_.flatMap(task.bundledTaskList, 'serviceInfo.tagNames'));
    let accountRow = '';
    let addressRow = '';
    let contactRow = '';
    let routedRow = '';
    let etaRow = '';
    let serviceTimeRow = '';
    const specialInstructions = this.escapeTimelineText(_.get(task, 'taskSpec.extraInfo'));
    let specialInstructionsRow = '';
    const isRouteBlockedByUser = route?.isBlockedByUser


    if (!taskIndex || taskIndex <= 0) {
      taskIndex = index || '';
    }

    if (!!serviceId && !externalId) {
      const hashIconCopy = angular.copy(this.$hashIcon);
      hashIconCopy.classList.add('margin-right-0');
      serviceIdRow = '<div class="info-row">'
        + hashIconCopy.outerHTML
        + '<span class="br-body-1">' + serviceId + '</span>'
        + '</div>'
    }

    if (!!externalId) {
      externalIdRow = '<div class="info-row">'
        + this.$hashIcon.outerHTML
        + '<span class="br-body-1">' + externalId + '</span>'
        + '</div>'
    }

    if (!!routeId) {
      routedRow = '<div class="info-row">'
        + this.$routedIcon.outerHTML
        + '<span class="br-body-1">' + routeId + '</span>'
        + '</div>'
    }

    if (!!courierPrice) {
      courierPriceRow = '<div class="info-row">'
        + this.$priceIcon.outerHTML
        + '<span class="br-body-1">' + this.$filter('translate')('Cost') + ': ' + courierPrice + '</span>'
        + '</div>'
    }

    if (packagesCount > 0) {
      packagesRow = '<div class="info-row">'
        + this.$packageIcon.outerHTML
        + '<span class="br-body-1 margin-right-5">X' + packagesCount + ',</span>'
        + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Weight') + ': ' + this.$filter('bringozWeight')(weight, true) + ',</span>'
        + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Volume') + ': ' + this.$filter('bringozVolume')(volume, true) + ',</span>'
        + '<span class="br-body-1">' + this.$filter('translate')('Product Value') + ': ' + this.$filter('packageTotalValue')(task.packageList[0], true) + '</span>'
        + '</div>'
    }

    let blockedIcon;
    if (!!isRouteBlockedByUser) {
      blockedIcon = document.createElement('IMG');
      blockedIcon.setAttribute("src", this.iconsUrl.blocked);
      blockedIcon.classList.add('bringoz-icon-small', 'white');
    }

    let relationIcon;
    if (relations && relations.length) {
      relationIcon = document.createElement('IMG');
      relationIcon.setAttribute("src", this.iconsUrl.relations);
      relationIcon.classList.add('bringoz-icon-small', 'white');
    }

    let lateIcon;
    if (isLate) {
      lateIcon = document.createElement('IMG');
      lateIcon.setAttribute("src", this.iconsUrl.late);
      lateIcon.classList.add('bringoz-icon-small', 'warn');
    }

    if (!_.isUndefined(timeZoneOffsetDiff) && timeZoneOffsetDiff !== 0) {
      timeWindowZoneRow = '<span class="info-row margin-left-5">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-1" style="color: #317AD5;">' + this.escapeTimelineText(this.$filter('timeWindow')(taskTimeWindow, timeZoneId)) + ' | </span>\n'
        + '<span class="br-body-1" style="color: #317AD5;">' + timeZoneIdText + ' (' + timeZoneOffsetDiff + this.$filter('translate')('hrs') + ')' + '</span>'
        + '</span>'
    }

    if (!_.isUndefined(timeZoneOffsetDiff) && !_.isUndefined(eta) && timeZoneOffsetDiff !== 0) {
      etaZoneRow = '<span class="info-row margin-left-5">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-1" style="color: #317AD5;">' + this.escapeTimelineText(this.$filter('bringozDate')({eta: eta}, 'eta', true, timeZoneId)) + ' | </span>\n'
        + '<span class="br-body-1" style="color: #317AD5;">' + timeZoneIdText + ' (' + timeZoneOffsetDiff + this.$filter('translate')('hrs') + ')' + '</span>'
        + '</span>'
    }

    if (purpose !== TaskPurposeType.Break) {
      accountRow = '<div class="info-row">'
        + this.$accountIcon.outerHTML
        + '<span class="br-body-1">' + accountName + '</span>'
        + '</div>';

      addressRow = '<div class="info-row">'
        + this.$addressIcon.outerHTML
        + '<span class="br-body-1">' + this.escapeTimelineText(this.$filter('bringozAddress')(task.taskSpec.address)) + '</span>'
        + '</div>';

      contactRow = '<div class="info-row">'
        + this.$contactIcon.outerHTML
        + '<span bringoz-ppi class="br-body-1 margin-right-10">' + contactName + '</span>'
        + this.$phoneIcon.outerHTML
        + '<span bringoz-ppi class="br-body-1">' + this.escapeTimelineText(this.$filter('bringozPhone')(contactPhone, '--')) + '</span>'
        + '</div>';

      serviceTimeRow = '<div class="info-row">'
        + this.$serviceTimeIcon.outerHTML
        + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Service Time') + ': ' + this.$filter('serviceTime')(serviceTime) + ', </span>'
        + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Idle Time') + ': ' + this.$filter('bringozTimeConvert')(idleInMili, true) + '</span>'
        + '</div>';

      etaRow = '<div class="info-row">'
        + this.$etaIcon.outerHTML
        + '<span class="br-body-1' + (isLate ? 'warn' : '') + '">' + this.$filter('bringozTime')(analysis, 'eta') + '</span>'
        + (lateIcon ? lateIcon.outerHTML : '')
        + etaZoneRow
        + '</div>';
    }

    if (!!tags) {
      tagsRow = '<div class="info-row">'
        + this.$tagIcon.outerHTML
        + '<span class="br-body-1 margin-right-10">' + this.getTagsNames(tags) + '</span>'
        + '</div>'
    }

    if (!!specialInstructions) {
      specialInstructionsRow = '<div class="info-row">'
        + this.$noteWhiteIcon.outerHTML
        + '<span class="br-body-1 text-ellipsis">' + specialInstructions + '</span>'
        + '</div>'
    }

    return '<div class="header-container" >'
      + '<div class="task-status ' + status + '">' + this.$filter('translate')('STATUS_TAG.' + status) + '</div>'
      + '<span style="color: ' + purposeColor + '" class="task-purpose br-body-2 font-weight-600 margin-left-5">' + tooltipHeader + ' ' + taskIndex + '</span>'
      + (blockedIcon ? blockedIcon.outerHTML : '')
      + serviceIdRow
      + '</div>'
      + (relationIcon ? relationIcon.outerHTML : '')
      + externalIdRow
      + routedRow
      + accountRow
      + addressRow
      + contactRow
      + '<div class="info-row">'
      + this.$timeWindowIcon.outerHTML
      + '<span class="br-body-1">' + this.$filter('timeWindow')(taskTimeWindow) + '</span>'
      + timeWindowZoneRow
      + '</div>'
      + etaRow
      + serviceTimeRow
      + tagsRow
      + packagesRow
      + courierPriceRow
      + specialInstructionsRow
  }

  getItineraryTaskTimelineItemTooltip(task, taskEtaWindow, relations, index?) {

    const purpose = task.taskSpec.purpose;
    const purposeColor = this.escapeTimelineText(this.taskPurposeToColorMap[purpose]);
    const status = this.escapeTimelineText(task.status);
    const isLate = _.get(task, 'analysis.late', 0) > 0;
    const analysis = _.get(task, 'analysis');
    const eta = _.get(task, 'analysis.eta');
    let serviceTime;
    if(!!task.taskSpec.detailedServiceTime) {
      const detailedServiceTime = task.taskSpec.detailedServiceTime;
      serviceTime = (detailedServiceTime.workTime || 0) + (detailedServiceTime.entryTime || 0) + (detailedServiceTime.exitTime || 0) + (detailedServiceTime.packagesTime || 0);
    } else {
      serviceTime = _.get(task, 'taskSpec.serviceTime');
    }
    const actualNotBefore = _.get(task, 'analysis.actualNotBefore', 0);
    const idleInMili = actualNotBefore > eta ? (actualNotBefore - eta) : 0;
    const weight = _.get(task, 'analysis.currentLoad.weight');
    const volume = _.get(task, 'analysis.currentLoad.dimensions.cube');
    let taskIndex = index || _.get(task, 'analysis.daySequence');
    const notBefore = _.get(task, 'taskSpec.notBefore');
    const notAfter = _.get(task, 'taskSpec.notAfter');
    const taskTimeWindow = {notBefore: notBefore, notAfter: notAfter};
    const timeZoneId = _.get(task, 'taskSpec.address.zoneIdName');
    const timeZoneIdText = this.escapeTimelineText(timeZoneId);
    const timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(timeZoneId, notBefore);
    const accountName = this.escapeTimelineText(_.get(task, 'accountReference.name', '--'));
    const packagesCount = _.get(task, 'packageList[0].count');
    const isBundle = _.isEqual(task.taskType, 'BundledStopover');
    const tooltipHeader = this.escapeTimelineText((isBundle ? this.$filter('translate')('Multi') + ' ' : '') + purpose);
    const serviceId = this.escapeTimelineText(task.serviceId);
    const courierPrice = this.escapeTimelineText(this.$filter('taskCourierPrice')(task));
    let packagesRow = '';
    let serviceIdRow = '';
    let timeWindowZoneRow = '';
    let etaZoneRow = '';
    let courierPriceRow = '';

    let lateIcon;
    if (isLate) {
      lateIcon = document.createElement('IMG');
      lateIcon.setAttribute("src", this.iconsUrl.late);
      lateIcon.classList.add('bringoz-icon-small', 'warn');
    }

    const etaTime = task.agentDepartureTime || task.agentArrivalTime || task.analysis?.eta;
    const textForEta = task.agentDepartureTime ? this.$filter('translate')('Completed') : (task.agentArrivalTime ? this.$filter('translate')('Arrived') : '');
    let etaRow = '<div class="info-row">'
      + ((task.agentDepartureTime || task.agentArrivalTime) ? this.$statusIcon.outerHTML : this.$etaIcon.outerHTML)
      + '<span class="br-body-1 margin-left-5' + (isLate ? 'warn' : '') + '">' + textForEta + ' ' + this.$filter('bringozTime')({eta: etaTime}, 'eta') + '</span>'
      + (lateIcon ? lateIcon.outerHTML : '')
      + etaZoneRow
      + '</div>'


    if (!taskIndex || taskIndex <= 0) {
      taskIndex = '';
    }

    if (!!serviceId) {
      // serviceIdRow = '<div class="info-row margin-left-20">'
      //   + this.$hashIcon.outerHTML
      //   + '<span class="br-body-2">' + serviceId + '</span>'
      //   + '</div>'
      const hashIconCopy = angular.copy(this.$hashIcon);
      hashIconCopy.classList.add('margin-right-0');
      serviceIdRow = `<div class="info-row margin-left-10">
                       ${hashIconCopy.outerHTML}
                       <span class="br-body-2">${serviceId}</span>
                      </div>`
    }

    if (!!courierPrice) {
      courierPriceRow = `<div class="info-row">
                       ${this.$priceIcon.outerHTML}
                       <span class="br-body-2">${this.$filter('translate')('Cost')}: ${courierPrice}</span>
                      </div>`
    }

    let relationIcon;
    if (relations && relations.length) {
      relationIcon = document.createElement('IMG');
      relationIcon.setAttribute("src", this.iconsUrl.relations);
      relationIcon.classList.add('bringoz-icon-small', 'white');
    }

    if (packagesCount > 0) {
      packagesRow = '<div class="info-row">'
        + this.$packageIcon.outerHTML
        + '<span class="br-body-1 margin-right-5">X' + packagesCount + ',</span>'
        + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Weight') + ': ' + this.$filter('bringozWeight')(weight, true) + ',</span>'
        + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Volume') + ': ' + this.$filter('bringozVolume')(volume, true) + ',</span>'
        + '<span class="br-body-1">' + this.$filter('translate')('Product Value') + ': ' + this.$filter('packageTotalValue')(task.packageList[0], true) + '</span>'
        + '</div>'
    }

    if (!_.isUndefined(timeZoneOffsetDiff) && timeZoneOffsetDiff !== 0) {
      timeWindowZoneRow = '<span class="info-row margin-left-5">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-1" style="color: #A7A7A7;">' + this.escapeTimelineText(this.$filter('timeWindow')(taskTimeWindow, timeZoneId)) + ' | </span>\n'
        + '<span class="br-body-1" style="color: #A7A7A7;">' + timeZoneIdText + ' (' + timeZoneOffsetDiff + this.$filter('translate')('hrs') + ')' + '</span>'
        + '</span>'
    }

    if (!_.isUndefined(timeZoneOffsetDiff) && !_.isUndefined(eta) && timeZoneOffsetDiff !== 0) {
      etaZoneRow = '<span class="info-row margin-left-5">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-1" style="color: #A7A7A7;">' + this.escapeTimelineText(this.$filter('bringozDate')({eta: eta}, 'eta', true, timeZoneId)) + ' | </span>\n'
        + '<span class="br-body-1" style="color: #A7A7A7;">' + timeZoneIdText + ' (' + timeZoneOffsetDiff + this.$filter('translate')('hrs') + ')' + '</span>'
        + '</span>'
    }

    return '<div class="header-container">'
      + '<div class="task-status ' + status + '">' + this.$filter('translate')('STATUS_TAG.' + status) + '</div>'
      + '<span style="color: ' + purposeColor + '" class="task-purpose br-body-2 font-weight-600 margin-left-5">' + tooltipHeader + ' ' + taskIndex + '</span>'
      + (relationIcon ? relationIcon.outerHTML : '')
      + serviceIdRow
      + '</div>'
      + '<div class="info-row">'
      + this.$accountIcon.outerHTML
      + '<span class="br-body-1">' + accountName + '</span>'
      + '</div>'
      + '<div class="info-row">'
      + this.$addressIcon.outerHTML
      + '<span class="br-body-1">' + this.escapeTimelineText(this.$filter('bringozAddress')(task.taskSpec.address)) + '</span>'
      + '</div>'
      + '<div class="info-row">'
      + this.$timeWindowIcon.outerHTML
      + '<span class="br-body-1">' + this.$filter('timeWindow')(taskTimeWindow) + '</span>'
      + timeWindowZoneRow
      + '</div>'
      + etaRow
      + '<div class="info-row">'
      + this.$serviceTimeIcon.outerHTML
      + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Service Time') + ': ' + this.$filter('serviceTime')(serviceTime) + ', </span>'
      + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Idle Time') + ': ' + this.$filter('bringozTimeConvert')(idleInMili, true) + '</span>'
      + '</div>'
      // + '<div class="info-row">'
      // + $etaWindowIcon.outerHTML
      // + '<span class="br-body-1">' + taskEtaWindow + '</span>'
      // + '</div>'
      + packagesRow
      + courierPriceRow;

  }

  ////////////////////////////
  // Task Oriented Tooltips
  ////////////////////////////
  getRouteTaskOrientedTimelineItemTooltip(task, taskEtaWindow, relations, index?, route?) {
    const purpose = task.taskSpec.purpose;
    const isBundle = _.isEqual(task.taskType, 'BundledStopover');
    const purposeColor = this.escapeTimelineText(this.taskPurposeToColorMap[purpose]);
    const externalId = this.escapeTimelineText(_.get(task, 'serviceExternalId'));
    const status = this.escapeTimelineText(task.status);
    const isLate = _.get(task, 'routeAnalysis.late', 0) > 0;
    const analysis = _.get(task, 'routeAnalysis');
    const eta = _.get(task, 'routeAnalysis.eta');
    let serviceTime;
    if(!!task.taskSpec.detailedServiceTime) {
      const detailedServiceTime = task.taskSpec.detailedServiceTime;
      serviceTime = (detailedServiceTime.workTime || 0) + (detailedServiceTime.entryTime || 0) + (detailedServiceTime.exitTime || 0) + (detailedServiceTime.packagesTime || 0);
    } else {
      serviceTime = _.get(task, 'taskSpec.serviceTime');
    }
    const actualNotBefore = _.get(task, 'routeAnalysis.actualNotBefore', 0);
    const idleInMili = actualNotBefore > eta ? (actualNotBefore - eta) : 0;
    const weight = this.$filter('servicePackageWeight')(_.get(task, 'packageList[0].items'), true);
    const volume = this.$filter('servicePackageVolume')(_.get(task, 'packageList[0].items'), true);
    let taskIndex = _.get(task, 'routeAnalysis.daySequence');
    const notBefore = _.get(task, 'taskSpec.notBefore');
    const notAfter = _.get(task, 'taskSpec.notAfter');
    const taskTimeWindow = {notBefore: notBefore, notAfter: notAfter};
    const timeZoneId = _.get(task, 'taskSpec.address.zoneIdName');
    const timeZoneIdText = this.escapeTimelineText(timeZoneId);
    const timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(timeZoneId, notBefore);
    const accountName = this.escapeTimelineText(_.get(task, 'accountReference.name', '--'));
    const packagesCount = _.get(task, 'packageList[0].count', '--');
    let packagesRow = '';
    const tooltipHeader = this.escapeTimelineText((isBundle ? this.$filter('translate')('Multi') + ' ' : '') + purpose);
    const serviceId = this.escapeTimelineText(task.serviceId);
    let serviceIdRow = '';
    let externalIdRow = '';
    let timeWindowZoneRow = '';
    let etaZoneRow = '';
    let tagsRow = '';
    const courierPrice = this.escapeTimelineText(this.$filter('taskCourierPrice')(task));
    let courierPriceRow = '';
    const contactName = this.escapeTimelineText(_.get(task, 'taskSpec.contact.fullName', '---'));
    const contactPhone = _.get(task, 'taskSpec.contact.phoneNo');
    const routeId = this.escapeTimelineText(_.get(task, 'routeId'));
    const tags = !isBundle ? _.get(task, 'serviceInfo.tagNames') : _.uniq(_.flatMap(task.bundledTaskList, 'serviceInfo.tagNames'));
    let routedRow = '';
    const specialInstructions = this.escapeTimelineText(_.get(task, 'taskSpec.extraInfo'));
    let specialInstructionsRow = '';
    const isRouteBlockedByUser = route?.isBlockedByUser


    if (!taskIndex || taskIndex <= 0) {
      taskIndex = index || '';
    }

    if (!!serviceId && !externalId) {
      const hashIconCopy = angular.copy(this.$hashIcon);
      hashIconCopy.classList.add('margin-right-0');
      serviceIdRow = '<div class="info-row">'
        + hashIconCopy.outerHTML
        + '<span class="br-body-1">' + serviceId + '</span>'
        + '</div>'
    }

    if (!!externalId) {
      externalIdRow = '<div class="info-row">'
        + this.$hashIcon.outerHTML
        + '<span class="br-body-1">' + externalId + '</span>'
        + '</div>'
    }

    if (!!routeId) {
      routedRow = '<div class="info-row">'
        + this.$routedIcon.outerHTML
        + '<span class="br-body-1">' + routeId + '</span>'
        + '</div>'
    }

    if (!!courierPrice) {
      courierPriceRow = '<div class="info-row">'
        + this.$priceIcon.outerHTML
        + '<span class="br-body-1">' + this.$filter('translate')('Cost') + ': ' + courierPrice + '</span>'
        + '</div>'
    }

    if (packagesCount > 0) {
      packagesRow = '<div class="info-row">'
        + this.$packageIcon.outerHTML
        + '<span class="br-body-1 margin-right-5">X' + packagesCount + ',</span>'
        + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Weight') + ': ' + weight + ',</span>'
        + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Volume') + ': ' + volume + ',</span>'
        + '<span class="br-body-1">' + this.$filter('translate')('Product Value') + ': ' + this.$filter('packageTotalValue')(task.packageList[0], true) + '</span>'
        + '</div>'
    }

    let blockedIcon;
    if (!!isRouteBlockedByUser) {
      blockedIcon = document.createElement('IMG');
      blockedIcon.setAttribute("src", this.iconsUrl.blocked);
      blockedIcon.classList.add('bringoz-icon-small', 'white');
    }

    let relationIcon;
    if (relations && relations.length) {
      relationIcon = document.createElement('IMG');
      relationIcon.setAttribute("src", this.iconsUrl.relations);
      relationIcon.classList.add('bringoz-icon-small', 'white');
    }

    let lateIcon;
    if (isLate) {
      lateIcon = document.createElement('IMG');
      lateIcon.setAttribute("src", this.iconsUrl.late);
      lateIcon.classList.add('bringoz-icon-small', 'warn');
    }

    if (!_.isUndefined(timeZoneOffsetDiff) && timeZoneOffsetDiff !== 0) {
      timeWindowZoneRow = '<span class="info-row margin-left-5">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-1" style="color: #317AD5;">' + this.escapeTimelineText(this.$filter('timeWindow')(taskTimeWindow, timeZoneId)) + ' | </span>\n'
        + '<span class="br-body-1" style="color: #317AD5;">' + timeZoneIdText + ' (' + timeZoneOffsetDiff + this.$filter('translate')('hrs') + ')' + '</span>'
        + '</span>'
    }

    if (!_.isUndefined(timeZoneOffsetDiff) && !_.isUndefined(eta) && timeZoneOffsetDiff !== 0) {
      etaZoneRow = '<span class="info-row margin-left-5">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-1" style="color: #317AD5;">' + this.escapeTimelineText(this.$filter('bringozDate')({eta: eta}, 'eta', true, timeZoneId)) + ' | </span>\n'
        + '<span class="br-body-1" style="color: #317AD5;">' + timeZoneIdText + ' (' + timeZoneOffsetDiff + this.$filter('translate')('hrs') + ')' + '</span>'
        + '</span>'
    }

    if (!!tags) {
      tagsRow = '<div class="info-row">'
        + this.$tagIcon.outerHTML
        + '<span class="br-body-1 margin-right-10">' + this.getTagsNames(tags) + '</span>'
        + '</div>'
    }

    if (!!specialInstructions) {
      specialInstructionsRow = '<div class="info-row">'
        + this.$noteWhiteIcon.outerHTML
        + '<span class="br-body-1 text-ellipsis">' + specialInstructions + '</span>'
        + '</div>'
    }

    return '<div class="header-container" >'
      + '<div class="task-status ' + status + '">' + this.$filter('translate')('STATUS_TAG.' + status) + '</div>'
      + '<span style="color: ' + purposeColor + '" class="task-purpose br-body-2 font-weight-600 margin-left-5">' + tooltipHeader + ' ' + taskIndex + '</span>'
      + (blockedIcon ? blockedIcon.outerHTML : '')
      + serviceIdRow
      + '</div>'
      + (relationIcon ? relationIcon.outerHTML : '')
      + externalIdRow
      + routedRow
      + '<div class="info-row">'
      + this.$accountIcon.outerHTML
      + '<span class="br-body-1">' + accountName + '</span>'
      + '</div>'
      + '<div class="info-row">'
      + this.$addressIcon.outerHTML
      + '<span class="br-body-1">' + this.escapeTimelineText(this.$filter('bringozAddress')(task.taskSpec.address)) + '</span>'
      + '</div>'
      + '<div class="info-row">'
      + this.$contactIcon.outerHTML
      + '<span bringoz-ppi class="br-body-1 margin-right-10">' + contactName + '</span>'
      + this.$phoneIcon.outerHTML
      + '<span bringoz-ppi class="br-body-1">' + this.escapeTimelineText(this.$filter('bringozPhone')(contactPhone, '---')) + '</span>'
      + '</div>'
      + '<div class="info-row">'
      + this.$timeWindowIcon.outerHTML
      + '<span class="br-body-1">' + this.$filter('timeWindow')(taskTimeWindow) + '</span>'
      + timeWindowZoneRow
      + '</div>'
      + '<div class="info-row">'
      + this.$etaIcon.outerHTML
      + '<span class="br-body-1' + (isLate ? 'warn' : '') + '">' + this.$filter('bringozTime')(analysis, 'eta') + '</span>'
      + (lateIcon ? lateIcon.outerHTML : '')
      + etaZoneRow
      + '</div>'
      + '<div class="info-row">'
      + this.$serviceTimeIcon.outerHTML
      + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Service Time') + ': ' + this.$filter('serviceTime')(serviceTime) + ', </span>'
      + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Idle Time') + ': ' + this.$filter('bringozTimeConvert')(idleInMili, true) + '</span>'
      + '</div>'
      + tagsRow
      + packagesRow
      + courierPriceRow
      + specialInstructionsRow
  }

  getItineraryTaskOrientedTimelineItemTooltip(task, taskEtaWindow, relations, index?) {

    const purpose = task.taskSpec.purpose;
    const purposeColor = this.escapeTimelineText(this.taskPurposeToColorMap[purpose]);
    const status = this.escapeTimelineText(task.status);
    const isLate = _.get(task, 'analysis.late', 0) > 0;
    const analysis = _.get(task, 'analysis');
    const eta = _.get(task, 'analysis.eta');
    let serviceTime;
    if(!!task.taskSpec.detailedServiceTime) {
      const detailedServiceTime = task.taskSpec.detailedServiceTime;
      serviceTime = (detailedServiceTime.workTime || 0) + (detailedServiceTime.entryTime || 0) + (detailedServiceTime.exitTime || 0) + (detailedServiceTime.packagesTime || 0);
    } else {
      serviceTime = _.get(task, 'taskSpec.serviceTime');
    }
    const actualNotBefore = _.get(task, 'analysis.actualNotBefore', 0);
    const idleInMili = actualNotBefore > eta ? (actualNotBefore - eta) : 0;
    const weight = this.$filter('servicePackageWeight')(_.get(task, 'packageList[0].items'), true);
    const volume = this.$filter('servicePackageVolume')(_.get(task, 'packageList[0].items'), true);
    let taskIndex = index || _.get(task, 'analysis.daySequence');
    const notBefore = _.get(task, 'taskSpec.notBefore');
    const notAfter = _.get(task, 'taskSpec.notAfter');
    const taskTimeWindow = {notBefore: notBefore, notAfter: notAfter};
    const timeZoneId = _.get(task, 'taskSpec.address.zoneIdName');
    const timeZoneIdText = this.escapeTimelineText(timeZoneId);
    const timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(timeZoneId, notBefore);
    const accountName = this.escapeTimelineText(_.get(task, 'accountReference.name', '--'));
    const packagesCount = _.get(task, 'packageList[0].count');
    const isBundle = _.isEqual(task.taskType, 'BundledStopover');
    const tooltipHeader = this.escapeTimelineText((isBundle ? this.$filter('translate')('Multi') + ' ' : '') + purpose);
    const serviceId = this.escapeTimelineText(task.serviceId);
    const courierPrice = this.escapeTimelineText(this.$filter('taskCourierPrice')(task));
    let packagesRow = '';
    let serviceIdRow = '';
    let timeWindowZoneRow = '';
    let etaZoneRow = '';
    let courierPriceRow = '';
    let etaRow: string = '';
    let etdRow: string = '';

    const agentEta = task.agentArrivalTime || task.analysis?.eta;
    const textForAgentEta = task.agentArrivalTime ? this.$filter('translate')('Arrived') : (task.analysis?.eta ? this.$filter('translate')('ETA') : undefined);
    const agentEtd = task.agentDepartureTime || task.analysis.etd;
    const textForAgentEtd = task.agentDepartureTime ? this.$filter('translate')('Completed') : (task.analysis?.etd ? this.$filter('translate')('ETD') : undefined);

    if (agentEta) {
      etaRow = '<div class="info-row">'
        + this.$statusIcon.outerHTML
        + '<span class="br-body-1' + (isLate ? 'warn' : '') + '">' + textForAgentEta + ' ' + this.$filter('bringozTime')({eta: agentEta}, 'eta') + '</span>'
        + (isLate ? this.$lateIcon.outerHTML : '')
        + '</div>'
    }

    if (agentEtd) {
      etdRow = '<div class="info-row">'
        + this.$statusIcon.outerHTML
        + '<span class="br-body-1' + (isLate ? 'warn' : '') + ' ">' + textForAgentEtd + ' ' + this.$filter('bringozTime')({eta: agentEtd}, 'eta') + '</span>'
        + (isLate ? this.$lateIcon.outerHTML : '')
        + '</div>'
    }


    if (!taskIndex || taskIndex <= 0) {
      taskIndex = '';
    }

    if (!!serviceId) {
      // serviceIdRow = '<div class="info-row margin-left-20">'
      //   + this.$hashIcon.outerHTML
      //   + '<span class="br-body-2">' + serviceId + '</span>'
      //   + '</div>'
      const hashIconCopy = angular.copy(this.$hashIcon);
      hashIconCopy.classList.add('margin-right-0');
      serviceIdRow = `<div class="info-row margin-left-10">
                       ${hashIconCopy.outerHTML}
                       <span class="br-body-2">${serviceId}</span>
                      </div>`
    }

    if (!!courierPrice) {
      courierPriceRow = `<div class="info-row">
                       ${this.$priceIcon.outerHTML}
                       <span class="br-body-2">${this.$filter('translate')('Cost')}: ${courierPrice}</span>
                      </div>`
    }

    let relationIcon;
    if (relations && relations.length) {
      relationIcon = document.createElement('IMG');
      relationIcon.setAttribute("src", this.iconsUrl.relations);
      relationIcon.classList.add('bringoz-icon-small', 'white');
    }

    if (packagesCount > 0) {
      packagesRow = '<div class="info-row">'
        + this.$packageIcon.outerHTML
        + '<span class="br-body-1 margin-right-5">X' + packagesCount + ',</span>'
        + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Weight') + ': ' + weight + ',</span>'
        + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Volume') + ': ' + volume + ',</span>'
        + '<span class="br-body-1">' + this.$filter('translate')('Product Value') + ': ' + this.$filter('packageTotalValue')(task.packageList[0], true) + '</span>'
        + '</div>'
    }

    if (!_.isUndefined(timeZoneOffsetDiff) && timeZoneOffsetDiff !== 0) {
      timeWindowZoneRow = '<span class="info-row margin-left-5">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-1" style="color: #A7A7A7;">' + this.escapeTimelineText(this.$filter('timeWindow')(taskTimeWindow, timeZoneId)) + ' | </span>\n'
        + '<span class="br-body-1" style="color: #A7A7A7;">' + timeZoneIdText + ' (' + timeZoneOffsetDiff + this.$filter('translate')('hrs') + ')' + '</span>'
        + '</span>'
    }

    if (!_.isUndefined(timeZoneOffsetDiff) && !_.isUndefined(eta) && timeZoneOffsetDiff !== 0) {
      etaZoneRow = '<span class="info-row margin-left-5">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-1" style="color: #A7A7A7;">' + this.escapeTimelineText(this.$filter('bringozDate')({eta: eta}, 'eta', true, timeZoneId)) + ' | </span>\n'
        + '<span class="br-body-1" style="color: #A7A7A7;">' + timeZoneIdText + ' (' + timeZoneOffsetDiff + this.$filter('translate')('hrs') + ')' + '</span>'
        + '</span>'
    }

    return '<div class="header-container">'
      + '<div class="task-status ' + status + '">' + this.$filter('translate')('STATUS_TAG.' + status) + '</div>'
      + '<span style="color: ' + purposeColor + '" class="task-purpose br-body-2 font-weight-600 margin-left-5">' + tooltipHeader + ' ' + taskIndex + '</span>'
      + (relationIcon ? relationIcon.outerHTML : '')
      + serviceIdRow
      + '</div>'
      + '<div class="info-row">'
      + this.$accountIcon.outerHTML
      + '<span class="br-body-1">' + accountName + '</span>'
      + '</div>'
      + '<div class="info-row">'
      + this.$addressIcon.outerHTML
      + '<span class="br-body-1">' + this.escapeTimelineText(this.$filter('bringozAddress')(task.taskSpec.address)) + '</span>'
      + '</div>'
      + '<div class="info-row">'
      + this.$timeWindowIcon.outerHTML
      + '<span class="br-body-1">' + this.$filter('timeWindow')(taskTimeWindow) + '</span>'
      + timeWindowZoneRow
      + '</div>'
      + etaRow
      + etdRow
      + '<div class="info-row">'
      + this.$serviceTimeIcon.outerHTML
      + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Service Time') + ': ' + this.$filter('serviceTime')(serviceTime) + ', </span>'
      + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Idle Time') + ': ' + this.$filter('bringozTimeConvert')(idleInMili, true) + '</span>'
      + '</div>'
      // + '<div class="info-row">'
      // + $etaWindowIcon.outerHTML
      // + '<span class="br-body-1">' + taskEtaWindow + '</span>'
      // + '</div>'
      + packagesRow
      + courierPriceRow;

  }

  getGeoTaskTimelineItemTooltip(task, taskEtaWindow, relations, index?) {

    const purpose = task.taskSpec.purpose;
    const purposeColor = this.escapeTimelineText(this.taskPurposeToColorMap[purpose]);
    const status = this.escapeTimelineText(task.status);
    const analysis = _.get(task, 'analysis');
    const eta = _.get(task, 'analysis.eta');
    let serviceTime;
    if(!!task.taskSpec.detailedServiceTime) {
      const detailedServiceTime = task.taskSpec.detailedServiceTime;
      serviceTime = (detailedServiceTime.workTime || 0) + (detailedServiceTime.entryTime || 0) + (detailedServiceTime.exitTime || 0) + (detailedServiceTime.packagesTime || 0);
    } else {
      serviceTime = _.get(task, 'taskSpec.serviceTime');
    }
    const actualNotBefore = _.get(task, 'analysis.actualNotBefore', 0);
    const idleInMili = actualNotBefore > eta ? (actualNotBefore - eta) : 0;
    const weight = this.$filter('servicePackageWeight')(_.get(task, 'packageList[0].items'), true);
    const volume = this.$filter('servicePackageVolume')(_.get(task, 'packageList[0].items'), true);
    let taskIndex = index || _.get(task, 'analysis.daySequence');
    const notBefore = _.get(task, 'taskSpec.notBefore');
    const notAfter = _.get(task, 'taskSpec.notAfter');
    const taskTimeWindow = {notBefore: notBefore, notAfter: notAfter};
    const timeZoneId = _.get(task, 'taskSpec.address.zoneIdName');
    const timeZoneIdText = this.escapeTimelineText(timeZoneId);
    const timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(timeZoneId, notBefore);
    const accountName = this.escapeTimelineText(_.get(task, 'accountReference.name', '--'));
    const packagesCount = _.get(task, 'packageList[0].count');
    const isBundle = _.isEqual(task.taskType, 'BundledStopover');
    const tooltipHeader = this.escapeTimelineText((isBundle ? this.$filter('translate')('Multi') + ' ' : '') + purpose);
    const serviceId = this.escapeTimelineText(task.serviceId);
    const courierPrice = this.escapeTimelineText(this.$filter('taskCourierPrice')(task));
    let packagesRow = '';
    let serviceIdRow = '';
    let timeWindowZoneRow = '';
    let etaZoneRow = '';
    let courierPriceRow = '';
    let etaRow: string = '';
    let etdRow: string = '';

    const geoEnterTime = task.analysis?.geofenceEventDataSegment?.startEntry?.timeStamp;
    const geoExitTime = task.analysis?.geofenceEventDataSegment?.endEntry?.timeStamp;
    let geoEnterRow = '';
    let geoExitRow = '';

    if (!!geoEnterTime) {
      geoEnterRow = '<div class="info-row">'
        + this.$geoTimeIcon.outerHTML
        + '<span class="br-body-1">' + this.$filter('translate')('Arrived (passive)') + ' ' + this.$filter('bringozDate')({time: geoEnterTime}, 'time', true) + '</span>'
        + '</div>';
    }

    if (!!geoExitTime) {
      geoExitRow = '<div class="info-row">'
        + this.$geoTimeIcon.outerHTML
        + '<span class="br-body-1">' + this.$filter('translate')('Completed (passive)') + ' ' + this.$filter('bringozDate')({time: geoExitTime}, 'time', true) + '</span>'
        + '</div>'
    }

    const agentEta = task.agentArrivalTime || task.analysis?.eta;
    const textForAgentEta = task.agentArrivalTime ? this.$filter('translate')('Arrived (manual)') : (task.analysis?.eta ? this.$filter('translate')('ETA') : undefined);
    const agentEtd = task.agentDepartureTime || task.analysis.etd;
    const textForAgentEtd = task.agentDepartureTime ? this.$filter('translate')('Completed (manual)') : (task.analysis?.etd ? this.$filter('translate')('ETD') : undefined);

    if (agentEta) {
      etaRow = '<div class="info-row">'
        + this.$statusIcon.outerHTML
        + '<span class="br-body-1">' + textForAgentEta + ' ' + this.$filter('bringozTime')({eta: agentEta}, 'eta') + '</span>'
        + '</div>'
    }

    if (agentEtd) {
      etdRow = '<div class="info-row">'
        + this.$statusIcon.outerHTML
        + '<span class="br-body-1">' + textForAgentEtd + ' ' + this.$filter('bringozTime')({eta: agentEtd}, 'eta') + '</span>'
        + '</div>'
    }

    if (!taskIndex || taskIndex <= 0) {
      taskIndex = '';
    }

    if (!!serviceId) {
      // serviceIdRow = '<div class="info-row margin-left-20">'
      //   + this.$hashIcon.outerHTML
      //   + '<span class="br-body-2">' + serviceId + '</span>'
      //   + '</div>'
      const hashIconCopy = angular.copy(this.$hashIcon);
      hashIconCopy.classList.add('margin-right-0');
      serviceIdRow = `<div class="info-row margin-left-10">
                       ${hashIconCopy.outerHTML}
                       <span class="br-body-2">${serviceId}</span>
                      </div>`
    }

    if (!!courierPrice) {
      courierPriceRow = `<div class="info-row">
                       ${this.$priceIcon.outerHTML}
                       <span class="br-body-2">${this.$filter('translate')('Cost')}: ${courierPrice}</span>
                      </div>`
    }

    let relationIcon;
    if (relations && relations.length) {
      relationIcon = document.createElement('IMG');
      relationIcon.setAttribute("src", this.iconsUrl.relations);
      relationIcon.classList.add('bringoz-icon-small', 'white');
    }

    if (packagesCount > 0) {
      packagesRow = '<div class="info-row">'
        + this.$packageIcon.outerHTML
        + '<span class="br-body-1 margin-right-5">X' + packagesCount + ',</span>'
        + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Weight') + ': ' + weight + ',</span>'
        + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Volume') + ': ' + volume + ',</span>'
        + '<span class="br-body-1">' + this.$filter('translate')('Product Value') + ': ' + this.$filter('packageTotalValue')(task.packageList[0], true) + '</span>'
        + '</div>'
    }

    if (!_.isUndefined(timeZoneOffsetDiff) && timeZoneOffsetDiff !== 0) {
      timeWindowZoneRow = '<span class="info-row margin-left-5">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-1" style="color: #A7A7A7;">' + this.escapeTimelineText(this.$filter('timeWindow')(taskTimeWindow, timeZoneId)) + ' | </span>\n'
        + '<span class="br-body-1" style="color: #A7A7A7;">' + timeZoneIdText + ' (' + timeZoneOffsetDiff + this.$filter('translate')('hrs') + ')' + '</span>'
        + '</span>'
    }

    if (!_.isUndefined(timeZoneOffsetDiff) && !_.isUndefined(eta) && timeZoneOffsetDiff !== 0) {
      etaZoneRow = '<span class="info-row margin-left-5">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-1" style="color: #A7A7A7;">' + this.escapeTimelineText(this.$filter('bringozDate')({eta: eta}, 'eta', true, timeZoneId)) + ' | </span>\n'
        + '<span class="br-body-1" style="color: #A7A7A7;">' + timeZoneIdText + ' (' + timeZoneOffsetDiff + this.$filter('translate')('hrs') + ')' + '</span>'
        + '</span>'
    }

    return '<div class="header-container">'
      + '<div class="task-status ' + status + '">' + this.$filter('translate')('STATUS_TAG.' + status) + '</div>'
      + '<span style="color: ' + purposeColor + '" class="task-purpose br-body-2 font-weight-600 margin-left-5">' + tooltipHeader + ' ' + taskIndex + '</span>'
      + (relationIcon ? relationIcon.outerHTML : '')
      + serviceIdRow
      + '</div>'
      + '<div class="info-row">'
      + this.$accountIcon.outerHTML
      + '<span class="br-body-1">' + accountName + '</span>'
      + '</div>'
      + '<div class="info-row">'
      + this.$addressIcon.outerHTML
      + '<span class="br-body-1">' + this.escapeTimelineText(this.$filter('bringozAddress')(task.taskSpec.address)) + '</span>'
      + '</div>'
      + '<div class="info-row">'
      + this.$timeWindowIcon.outerHTML
      + '<span class="br-body-1">' + this.$filter('timeWindow')(taskTimeWindow) + '</span>'
      + timeWindowZoneRow
      + '</div>'
      + geoEnterRow
      + geoExitRow
      + etaRow
      + etdRow
      + '<div class="info-row">'
      + this.$serviceTimeIcon.outerHTML
      + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Service Time') + ': ' + this.$filter('serviceTime')(serviceTime) + ', </span>'
      + '<span class="br-body-1 margin-right-5">' + this.$filter('translate')('Idle Time') + ': ' + this.$filter('bringozTimeConvert')(idleInMili, true) + '</span>'
      + '</div>'
      // + '<div class="info-row">'
      // + $etaWindowIcon.outerHTML
      // + '<span class="br-body-1">' + taskEtaWindow + '</span>'
      // + '</div>'
      + packagesRow
      + courierPriceRow;

  }

  getServiceAreasTooltip(serviceAreas) {
    return '<div class="header-container">'
      + '<span class="br-body-1">' + this.getServiceAreaNames(serviceAreas) + '</span>'
      + '</div>'
  }

  getResourceAllocationTimeWindowTooltip(allocation, serviceAreas, branchReferences?: BranchReferenceModel[]) {

    let timeWindowZoneRow = '';
    let branchesInfoRow = '';

    const zoneId = allocation.schedule.zoneIdName ? allocation.schedule.zoneIdName: allocation.resourceZoneId
    const timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(zoneId, allocation.schedule.startTime);

    if (!_.isUndefined(timeZoneOffsetDiff) && timeZoneOffsetDiff !== 0) {
      timeWindowZoneRow = '<span class="info-row">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-1">' + this.$filter('timeWindow')(allocation.schedule, zoneId) + ' | </span>\n'
        + '<span class="br-body-1">' + zoneId + ' (' + timeZoneOffsetDiff + this.$filter('translate')('hrs') + ')' + '</span>'
        + '</span>'
    } else {
      timeWindowZoneRow = '<span class="info-row">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-1">' + zoneId +  '</span>'
        + '</span>'
    }

    if (!!branchReferences?.length) {
      let branchNamesString = '';

      _.forEach(branchReferences, (branchRef, i) => {
        branchNamesString += this.escapeTimelineText(branchRef.name);
        if (i < branchReferences.length) {
          branchNamesString += '<br>'
        }
      });

      branchesInfoRow = '<div class="info-row">'
        + '<span class="br-body-1">' + this.$filter('translate')('Branches') + ': ' + branchNamesString + '</span>'
        + '</div>'
    }

    return '<div class="layout-column">'
      + timeWindowZoneRow
      + '<div class="info-row">'
      + '<span class="br-body-1">' + this.$filter('translate')('Service Areas') + ': ' + this.getServiceAreaNames(serviceAreas) + '</span>'
      + '</div>'
      + branchesInfoRow
      + '</div>';
  }

  getServiceAreaNames(serviceAreas) {
    let string = '';
    if (!serviceAreas || !serviceAreas.length) {
      return this.$filter('translate')('All');
    }

    _.forEach(serviceAreas, (area, i) => {
      string += this.escapeTimelineText(area.areaName);
      if (i < serviceAreas.length) {
        string += '<br>'
      }
    });
    return string;
  }

  private getTagsNames(tagNames) {
    let string = '';
    if (!tagNames || !tagNames.length) {
      return '';
    }

    _.forEach(tagNames, (name, i) => {
      string += this.escapeTimelineText(name);
      if (i < tagNames.length) {
        string += ', '
      }
    });
    return string;
  }

}

angular
  .module('bringoz.admin.commons')
  .service('bringozTimelineService', BringozTimelineService);
